// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3knbq","rootCenter":"LoadMoreObserver_rootCenter__2veYi","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3cUM4"};